module.exports = __webpack_public_path__ + "assets/img/00178.3c742a28.png";